<ng-container *ngIf="coreFacade.globalLoading$ | async as loadingState">
  <nx-ng-loader
    *ngIf="
      (loadingState.isLoading || loadingState.isUpdating) &&
      currentRoute !== routenames.POST_LOGIN
    "
    text="{{ loadingState.text | i18next }}"
  ></nx-ng-loader>
</ng-container>
<div class="layout lightGreyBackground">
  <!-- class 'coventry' will apply blue header -->
  <header class="appHeader">
    <div class="inner appContainer">
      <a class="logo" [href]="parentWebsiteUrl"
        ><img [src]="logo" [alt]="logoAltText"
      /></a>
      <nx-ng-basket
        *ngIf="showBasket"
        [basketItemsTotal]="basketItemsTotal"
        (basketClick)="handleBasketClicked()"
      ></nx-ng-basket>
    </div>
  </header>

  <nx-ng-breadcrumb
    *ngIf="showBreadcrumb && currentStep"
    [currentStep]="currentStep"
  ></nx-ng-breadcrumb>

  <nx-ng-current-page-indicator
    *ngIf="showCurrentPageIndicator"
    [currentPageTitle]="currentPageTitle"
    [showBackButton]="showBackButton"
  >
  </nx-ng-current-page-indicator>

  <div class="appContainer">
    <ng-content></ng-content>
  </div>
  <!-- footer component will go here -->
</div>
